import React from "react";
import BenefitCard from "./BenefitCard";
import BenefitCardSkeleton from "./BenefitCardSkeleton";
import { getBenefitId } from "../utils/BenefitUtils";

const BenefitGrid = ({
  benefits,
  selectedIds, 
  onToggleSelect,
  onViewDetails,
  loading = false,
  skeletonCount = 6,
}) => {
  if (loading) {
    return (
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-3 sm:gap-3.5">
        {Array.from({ length: skeletonCount }).map((_, i) => (
          <BenefitCardSkeleton key={`skeleton-${i}`} />
        ))}
      </div>
    );
  }

  const safeBenefits = Array.isArray(benefits) ? benefits.filter(Boolean) : [];

  if (safeBenefits.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-16 text-center gap-1">
        <p className="text-sm font-semibold text-slate-400">No benefits to show</p>
      </div>
    );
  }

  const isSingle = safeBenefits.length === 1;

  return (
    <div
      className={
        isSingle
          ? "flex justify-center"
          : "grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-3 sm:gap-3.5"
      }
    >
      {safeBenefits.map((benefit, i) => {
        const id = getBenefitId(benefit, i);
        return (
          <div key={id} className={isSingle ? "w-full max-w-sm" : ""}>
            <BenefitCard
              benefit={benefit}
              selected={selectedIds?.has(id)}
              onToggleSelect={onToggleSelect}
              onViewDetails={onViewDetails}
            />
          </div>
        );
      })}
    </div>
  );
};

export default BenefitGrid;